module.exports = __webpack_public_path__ + "img/glow-green-large.b65addd9.png";